/**
 * Os periodos que a ficha do paciente oferece.
 *
 * O VOCABULARIO e o do `components/period`; o que mora aqui e quais desses atalhos
 * ESTA ficha oferece e o codigo de cada um no endereco.
 *
 * ## Por que a tabela mora aqui, e nao em cada montagem
 *
 * A ficha e um pedaco de tela que TRES places hospedam - o detalhe do colaborador,
 * o detalhe do monitoramento e o historico compartilhado -, e os tres carregam o
 * periodo no endereco deles. Se cada um tivesse a sua tabela, um link do detalhe
 * abriria o compartilhado noutro periodo sem ninguem decidir que deveria.
 *
 * Isso ja tinha acontecido: o detalhe do colaborador escrevia o periodo pela tabela
 * de codigos (`h=1`) e o detalhe do monitoramento escrevia a palavra crua
 * (`h=MONTH`) - no MESMO nome de parametro. Os dois liam de volta so o que eles
 * mesmos escreviam, entao o desacordo nunca aparecia em tela.
 *
 * ## O que mudou
 *
 * Eram tres janelas fixas - Dia, Semana e Mes - ancoradas numa data. Nao havia como
 * olhar o trimestre de um atleta nem uma quinzena de recuperacao especifica. As tres
 * continuam existindo como intervalo, e agora ao lado de outras quatro.
 */
export const PATIENT_PERIODS = ['1d', '7d', '14d', '30d', '90d', 'month', 'last-month', 'custom'];
/**
 * O codigo de cada periodo no endereco.
 *
 * `0`, `1` e `2` eram WEEK, MONTH e DAY, e continuam querendo dizer o mesmo
 * intervalo: sete dias, trinta dias e um dia. Link antigo abre onde sempre abriu.
 */
export const PATIENT_PERIOD_CODES = {
    '0': '7d',
    '1': '30d',
    '2': '1d',
    '3': '14d',
    '4': '90d',
    '5': 'month',
    '6': 'last-month',
    '7': 'custom'
};
/** Os atalhos da ficha, na ordem em que aparecem no seletor. */
export const PATIENT_SHORTCUTS = PATIENT_PERIODS;
//# sourceMappingURL=patient-analytics.periods.js.map